import {
  getAppEnv,
  getEnv,
  getEnvNumberList,
  getFirebaseEnvPrefix,
  getNodeEnv,
  isLocalhostApp,
  isNodeDevelopment,
  isNodeProduction,
  isProductionApp,
} from './env';

const constants = {
  // NODE_ENV (build mode) — set by react-scripts, not .env
  nodeEnv: getNodeEnv(),
  isNodeProduction: isNodeProduction(),
  isNodeDevelopment: isNodeDevelopment(),

  // REACT_APP_ENV (deployment target)
  environment: getAppEnv(),
  env: getFirebaseEnvPrefix(),
  isLocalhost: isLocalhostApp(),
  isProductionApp: isProductionApp(),

  apiHost: getEnv('REACT_APP_API_HOST'),
  firstPartyName: getEnv('REACT_APP_FIRST_PARTY_NAME'),
  workspaceId: getEnv('REACT_APP_WORKSPACE_ID'),
  masterApi: getEnv('REACT_APP_API_MASTER_API'),
  emaiLDomain: getEnv('REACT_APP_EMAIL_DOMAIN'),
  obligationsUrl: getEnv('REACT_APP_OBLIGATIONS_URL'),
  recoveryUrl: getEnv('REACT_APP_RECOVERY_URL'),
  hostingerApiKey: getEnv('REACT_APP_HOSTINGER_API_KEY'),
  userId: getEnv('REACT_APP_USER_ID'),
  sharePointName: getEnv('REACT_APP_SHAREPOINT_NAME'),
  sharePointUser: getEnv('REACT_APP_SHAREPOINT_USER'),
  onedriveUserId: getEnv('REACT_APP_ONEDRIVE_USER_ID'),
  wordeditorApi: getEnv('REACT_APP_DOCXEDITOR_API_HOST'),
  licenseKey: getEnv('REACT_APP_DOCXEDITOR_LICENSE_KEY'),
  agreementDetailActionRoleIds: getEnvNumberList(
    'REACT_APP_AGREEMENT_DETAIL_ACTION_ROLE_IDS',
    [1, 2, 4],
  ),
};

export default constants;
